var _ellipse, _path, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 8,
    rx: 5.33333,
    ry: 5.33333,
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C22.2091 12 24 10.2091 24 8C24 5.79086 22.2091 4 20 4",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 22.6667,
    rx: 9.33333,
    ry: 5.33333,
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6667C26.339 19.1796 28 20.4786 28 22C28 23.3724 26.6484 24.5639 24.6667 25.1606",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsers);
export default __webpack_public_path__ + "static/media/ic_users.cc9f3ab9028a446d3879470bc06bcdd5.svg";
export { ForwardRef as ReactComponent };